import {
  AppBar,
  Toolbar,
  Button,
  Box,
  IconButton,
  Collapse,
  Slide,
  useScrollTrigger,
} from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import { useLocation, Link } from 'react-router-dom';
import { useState, useEffect } from 'react';
import { getImageUrl } from '../../utils';

const logo = getImageUrl('pilates-logo-blue.png');

function HideOnScroll({ children }) {
  const trigger = useScrollTrigger();
  return (
    <Slide appear={false} direction="down" in={!trigger}>
      <Box>{children}</Box>
    </Slide>
  );
}

const Navbar = () => {
  const location = useLocation();
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    window.scrollTo(0, 0);
    setMenuOpen(false); // Close menu on navigation
  }, [location.pathname]);

  const menuItems = [
    { label: 'Startsida', path: '/' },
    { label: 'Medlemsskap', path: '/sidepages/membership-info' },
    { label: 'Klasser', path: '/sidepages/klasses' },
    { label: 'Personlig Träning', path: '/sidepages/personaltraining-info' },
    { label: 'Bra Att Veta', path: '/sidepages/bra-att-veta' },
    { label: 'Om Pilates Höganäs', path: '/sidepages/about-info' },
  ];

  return (
    <HideOnScroll>
      <>
        <AppBar
          position="sticky"
          sx={{
            backgroundColor: 'rgba(255, 255, 255, 0.75)',
            backdropFilter: 'blur(10px)',
            boxShadow: '0 8px 16px rgba(0,0,0,0.06)',
            px: { xs: 2, md: 4 },
            py: 1,
            zIndex: 1200,
          }}
        >
          <Toolbar sx={{ justifyContent: 'space-between', alignItems: 'center' }}>
            {/* Logo */}
            <Box sx={{ flex: 1 }}>
              <Link to="/">
                <img
                  src={logo}
                  alt="Pilates Höganäs"
                  style={{ height: '48px', width: 'auto', cursor: 'pointer' }}
                />
              </Link>
            </Box>

            {/* Desktop Menu */}
            <Box sx={{ display: { xs: 'none', md: 'flex' }, gap: 3, alignItems: 'center' }}>
              <Button
                component={Link}
                to="/sidepages/schema"
                sx={{
                  position: 'relative',
                  color: '#00b5bf',
                  fontWeight: 600,
                  fontSize: '1.1rem',
                  textTransform: 'none',
                  '&::after': {
                    content: '""',
                    position: 'absolute',
                    bottom: -2,
                    left: 0,
                    width: 0,
                    height: '2px',
                    backgroundColor: '#00b5bf',
                    transition: 'width 0.3s ease',
                  },
                  '&:hover': {
                    color: '#007C85',
                    transform: 'translateY(-1px)',
                    '&::after': {
                      width: '100%',
                    },
                  },
                }}
              >
                Schema
              </Button>

              <Button
                onClick={() => setMenuOpen((prev) => !prev)}
                sx={{
                  position: 'relative',
                  color: '#00b5bf',
                  fontWeight: 600,
                  fontSize: '1.1rem',
                  textTransform: 'none',
                  '&::after': {
                    content: '""',
                    position: 'absolute',
                    bottom: -2,
                    left: 0,
                    width: 0,
                    height: '2px',
                    backgroundColor: '#00b5bf',
                    transition: 'width 0.3s ease',
                  },
                  '&:hover': {
                    color: '#007C85',
                    transform: 'translateY(-1px)',
                    '&::after': {
                      width: '100%',
                    },
                  },
                }}
              >
                Meny
              </Button>

              <Button
                href="https://pilateshoganas.wondr.se/"
                target="_blank"
                rel="noopener noreferrer"
                sx={{
                  background: 'linear-gradient(135deg,rgb(37, 112, 162), #00b5bf)',
                  color: 'white',
                  px: 3,
                  py: 1,
                  borderRadius: '999px',
                  fontWeight: 600,
                  '&:hover': {
                  background: 'linear-gradient(135deg,rgb(22, 65, 93),rgb(0, 111, 117))',
                  transform: 'translateY(-2px)',
                  boxShadow: '0 8px 24px rgba(0,0,0,0.15)',
                },
                }}
              >
                Logga in
              </Button>
            </Box>

            {/* Mobile Menu Button */}
            <Box sx={{ display: { xs: 'flex', md: 'none' }, alignItems: 'center' }}>
              <IconButton
                onClick={() => setMenuOpen((prev) => !prev)}
                sx={{ color: '#00b5bf' }}
              >
                <MenuIcon />
              </IconButton>
            </Box>
          </Toolbar>
        </AppBar>

        {/* Mobile Drawer Below */}
        {menuOpen && (
          <Collapse in={menuOpen} timeout="auto" unmountOnExit>
            <Box
              sx={{
                backgroundColor: '#E8FCFF',
                px: 4,
                py: 2,
                display: 'flex',
                flexDirection: 'column',
                gap: 1,
                boxShadow: '0 8px 24px rgba(0,0,0,0.05)',
              }}
            >
              {menuItems.map((item) => (
                <Button
                  key={item.label}
                  component={Link}
                  to={item.path}
                  sx={{
                    color: '#007C85',
                    fontSize: '1rem',
                    textTransform: 'none',
                    justifyContent: 'flex-start',
                  }}
                >
                  {item.label}
                </Button>
              ))}
            </Box>
          </Collapse>
        )}
      </>
    </HideOnScroll>
  );
};

export default Navbar;
